import React from 'react';
import TravelServicePage from './TravelServicePage';

const taxisConfig = {
  name: 'Airport Taxis',
  tagline: 'Arrive and depart without friction',
  description:
    'Schedule transfers that track live flight data, driver ETAs, and hotel readiness so you can move effortlessly.',
  heroImage: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=1600',
  accent: '#facc15',
  metrics: [
    { value: '98', label: 'cities covered' },
    { value: '8min', label: 'average wait time' },
    { value: '4.95★', label: 'traveler rating' }
  ],
  highlights: [
    {
      icon: '🚕',
      title: 'Flight-synced pickups',
      description: 'Drivers adjust in real-time if your plane lands early, late, or at a different gate.'
    },
    {
      icon: '🛡️',
      title: 'Safety first',
      description: 'Verified drivers, live tracking, and shareable rides give peace of mind for every traveller.'
    },
    {
      icon: '🔄',
      title: 'One-tap changes',
      description: 'Need to reroute? Modify destinations or add stops without hurdling through call centers.'
    }
  ],
  journey: [
    {
      title: 'Book alongside flights',
      description: 'Add transfers the moment you confirm flights so arrivals and departures sync automatically.'
    },
    {
      title: 'Track every heartbeat',
      description: 'Monitor driver approach, vehicle type, and license details. Share the journey with loved ones.'
    },
    {
      title: 'Relax en route',
      description: 'Enjoy curated playlists, bottled water, and rest mode lighting for red-eye arrivals.'
    },
    {
      title: 'Rate and reward',
      description: 'Reward top drivers instantly and earn loyalty credits that apply to future stays or rides.'
    }
  ],
  testimonials: [
    {
      quote:
        'Our VIPs never wait at arrivals anymore. Drivers even adjust if the baggage carousel changes—mind blown.',
      name: 'Laura Jensen',
      role: 'Guest Experience, Aurora Hotels'
    },
    {
      quote:
        'Travelling with kids felt easy. The driver tracked our late-night flight and had child seats ready.',
      name: 'The Martins Family',
      role: 'Frequent Travelers'
    }
  ],
  cta: {
    title: 'Never miss a beat between sky and city',
    description: 'Bundle transfers with your flight and stay. InnBotics keeps every arrival silky smooth.',
    actions: [
      { label: 'Schedule a taxi', href: '/booking', primary: true },
      { label: 'Manage my itinerary', href: '/dashboard', primary: false }
    ]
  }
};

const TaxisPage = () => <TravelServicePage config={taxisConfig} />;

export default TaxisPage;
